import { AdRoutePageContent } from '@features/market/route/Route.FormPageContent';

export default function RouteAddPage() {
    return <AdRoutePageContent />;
}
